import axios from "@/lib/axios";

export type UpdateAdditionalCommentsRequestParams = {
  companyId: string;
  quizId: string;
  responseId: string;
  additionalComments: string;
};

export type UpdateAdditionalCommentsResponse = void;

export const updateAdditionalComments = (
  params: UpdateAdditionalCommentsRequestParams,
) =>
  axios
    .put<UpdateAdditionalCommentsResponse>(
      `/v1/companies/${params.companyId}/application-quizzes/${params.quizId}/responses/${params.responseId}/additional-comments`,
      {
        additionalComments: params.additionalComments,
      },
    )
    .then((res) => res.data);
